<button
  class="theme-toggle"
  (click)="toggleTheme()"
  [attr.aria-label]="'Toggle theme'"
>
  @if (themeService.theme() === 'dark') {
  <span>☀️</span>
  } @else {
  <span>🌓</span>
  }
</button>
